export const undefinedRecordNames = (object, firstKey, secondKey) => {
  try {
    return object[firstKey][secondKey];
  } catch (error) {
    return "";
  }
};
